import { Adapter as r, getAdapter as l } from "../../../adapter.js";
import { LoyaltyProgrammeAdapter as a } from "../loyaltyProgramme/loyaltyProgramme.adapter.js";
import { TierAdapter as t } from "../tier/tier.adapter.js";
import { LoyaltyAccountModel as o } from "./loyaltyAccount.model.js";
class s extends r {
  adapt(e) {
    return new o({
      loyaltyId: e.loyalty_id,
      internalLoyaltyId: e.internal_loyalty_id,
      status: e.status,
      accBalance: e.acc_balance,
      balance: e.balance,
      maxBalance: e.max_balance,
      userFullName: e.user_full_name,
      userId: e.user_id,
      userName: e.user_name,
      loyalty: l(a).adapt(e.loyalty),
      tier: l(t).adapt(e.tier)
    });
  }
  serialize(e) {
  }
}
export {
  s as LoyaltyAccountAdapter
};
//# sourceMappingURL=loyaltyAccount.adapter.js.map
